import { Link } from 'react-router-dom';

export default function FinalCTA() {
  return (
    <section className="relative py-32 px-6 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0a525701037d1ab3a2873de6b8973be4.jpg"
          alt="Premium outdoor transformation — Dippel's Outdoor Services Florida"
          className="w-full h-full object-cover object-center"
        />
        {/* Dark cinematic overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/70 to-black/50"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
      </div>

      {/* Left accent line */}
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-transparent via-gold to-transparent opacity-70"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto">
        <div className="max-w-[640px]">
          <div className="flex items-center gap-3 mb-7">
            <div className="h-px w-10 bg-gold"></div>
            <span className="text-gold font-sans text-[11px] font-semibold tracking-[0.28em] uppercase">
              Begin Your Transformation
            </span>
          </div>

          <h2 className="font-serif text-white font-bold leading-tight mb-7" style={{ fontSize: 'clamp(36px, 4.5vw, 64px)' }}>
            The Outdoor Space
            <br />
            You&apos;ve Imagined{' '}
            <em className="text-gold not-italic">Deserves</em>
            <br />
            to Exist.
          </h2>

          <p className="text-white/60 text-base leading-relaxed mb-10 max-w-md">
            Premium fencing, pavers, landscapes, lighting, and sheds — delivered with precision across Palm Coast, Ormond Beach, Daytona Beach &amp; the Florida east coast. Free estimate, transparent pricing, guaranteed results.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2.5 bg-gold text-charcoal font-bold text-[15px] rounded-full hover:bg-gold-light transition-colors whitespace-nowrap"
              style={{ padding: '1.1rem 2.5rem' }}
            >
              <i className="ri-pencil-ruler-2-line"></i>
              Request a Design Consultation
            </Link>
            <a
              href="tel:3863014399"
              className="inline-flex items-center justify-center gap-2.5 border border-white/30 text-white font-semibold text-[15px] rounded-full hover:border-white/60 hover:bg-white/8 transition-all whitespace-nowrap"
              style={{ padding: '1.1rem 2.25rem' }}
            >
              <i className="ri-phone-fill text-gold"></i>
              (386) 301-4399
            </a>
          </div>

          {/* Trust signals */}
          <div className="flex flex-wrap gap-x-7 gap-y-3 pt-8 border-t border-white/15">
            {[
              { icon: 'ri-shield-check-fill', text: 'Licensed & Insured' },
              { icon: 'ri-star-fill', text: '5-Star Google Rated' },
              { icon: 'ri-thumb-up-fill', text: '100% Satisfaction Guaranteed' },
              { icon: 'ri-map-pin-2-fill', text: 'Serving 6 Florida Cities' },
            ].map((b, i) => (
              <div key={i} className="flex items-center gap-2 text-white/50">
                <i className={`${b.icon} text-gold text-sm`}></i>
                <span className="text-[13px]">{b.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
